import React from 'react'
import { connect } from 'react-redux'

import {
    homeErrorSelector,
    homeLoadingSelector,
    homeProductsSelector
} from 'store/selectors/home'

import DetailProductHeader from './components/DetailProductHeader'
import DetailProductFAQ from './components/DetailProductFAQ'
import ProductTudoFlexibleBenefits from './components/ProductTudo/ProductTudoFlexibleBenefits'
import ProductTudoFullExperience from './components/ProductTudo/ProductTudoFullExperience'
import FullLoading from 'components/FullLoading'
import ProductTudoHowIsPat from './components/ProductTudo/ProductTudoHowIsPat'

import { Container, Content } from './DetailProduct.style'

const DetailProductTudoPage = ({ products, loading, error }) => {
    const type = 'TUDO'
    const product = products.find((p) => p.productType === type)

    if (loading || error) {
        return (
            <Container className="internal-product-content loading">
                <FullLoading />
            </Container>
        )
    }

    return (
        <Container>
            <DetailProductHeader type={type} data={product} />
            <Content>
                <ProductTudoFlexibleBenefits />
                <ProductTudoFullExperience />
                <ProductTudoHowIsPat />
                <DetailProductFAQ type={type} data={product} />
            </Content>
        </Container>
    )
}

const mapStateToProps = (state) => ({
    error: homeErrorSelector(state),
    loading: homeLoadingSelector(state),
    products: homeProductsSelector(state)
})

export default connect(mapStateToProps)(DetailProductTudoPage)
